export default {"src":"/_next/static/media/app-store-btn.1af74803.svg","height":238,"width":800,"blurWidth":0,"blurHeight":0};